import React, { useEffect, useState } from "react";
import api from "../api";

const AdminAccomodation = () => {
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [list, setList] = useState([]);
  const [events, setEvents] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({
    event: "",
    hotel: "",
    hargaKamar: "",
    typeKamar: "",
    keterangan: ""
  });
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const url = search
      ? `${apiUrl}/api/accomodation/search?page=${page}&size=${size}&q=${encodeURIComponent(search)}`
      : `${apiUrl}/api/accomodation?page=${page}&size=${size}`;
    api.get(url)
      .then(res => {
        setList(res.data.content);
        setTotalPages(res.data.totalPages);
      });
    api.get(`${apiUrl}/api/events?page=0&size=100`)
      .then(res => setEvents(res.data.content));
    api.get(`${apiUrl}/api/hotel?page=0&size=100`)
      .then(res => setHotels(res.data.content));
  }, [apiUrl, page, size, showModal, search]);

  const openCreate = () => {
    setEditId(null);
    setForm({
      event: "",
      hotel: "",
      hargaKamar: "",
      typeKamar: "",
      keterangan: ""
    });
    setShowModal(true);
  };

  const openEdit = (item) => {
    setEditId(item.id);
    setForm({
      event: item.event?.id || "",
      hotel: item.hotel?.id || "",
      hargaKamar: item.hargaKamar,
      typeKamar: item.typeKamar,
      keterangan: item.keterangan
    });
    setShowModal(true);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const data = new FormData();
    data.append("event", form.event);
    data.append("hotel", form.hotel);
    data.append("hargaKamar", form.hargaKamar);
    data.append("typeKamar", form.typeKamar);
    data.append("keterangan", form.keterangan);
    try {
      if (editId) {
        await api.put(`${apiUrl}/api/accomodation/${editId}`, data);
      } else {
        await api.post(`${apiUrl}/api/accomodation`, data);
      }
      setShowModal(false);
    } catch {
      alert("Gagal simpan data");
    }
  };

  const handleDelete = async id => {
    if (!window.confirm("Yakin hapus data ini?")) return;
    try {
      await api.delete(`${apiUrl}/api/accomodation/${id}`);
      setList(list.filter(x => x.id !== id));
    } catch {
      alert("Gagal hapus data");
    }
  };

  const setPageListItems = (event) => {
    const value = parseInt(event.target.getAttribute('data-value'), 10);
    setSize(value);
    setPage(0);
  };

  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Accomodation Management</h2>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <button className="btn btn-primary" onClick={openCreate}>
                Create Accomodation
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="card">
            <div className="row g-0">
              <div className="col-md-auto col-sm-12">
                <div className="input-group input-group-flat w-auto">
                  <input
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    placeholder="Cari Hotel/Event"
                    value={search}
                    onChange={e => { setSearch(e.target.value); setPage(0); }}
                  />
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table card-table table-vcenter text-nowrap datatable table-hover">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Event</th>
                    <th>Nama Hotel</th>
                    <th>Harga Kamar</th>
                    <th>Type Kamar</th>
                    <th>Keterangan</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {list.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="text-center">Data tidak ditemukan</td>
                    </tr>
                  ) : list.map((item, idx) => (
                    <tr key={item.id}>
                      <td>{page * size + idx + 1}</td>
                      <td>{item.event?.eventCode} - {item.event?.title}</td>
                      <td>{item.hotel?.namaHotel}</td>
                      <td>{item.hargaKamar && Number(item.hargaKamar).toLocaleString("id-ID", { style: "currency", currency: "IDR" })}</td>
                      <td>{item.typeKamar}</td>
                      <td>{item.keterangan}</td>
                      <td>
                        <button className="btn btn-sm btn-warning me-1" onClick={() => openEdit(item)}>Edit</button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="card-footer d-flex align-items-center">
              <div className="dropdown">
                <a className="btn dropdown-toggle" data-bs-toggle="dropdown">
                  <span id="page-count" className="me-1">{size}</span>
                  <span>records</span>
                </a>
                <div className="dropdown-menu">
                  {[10, 20, 50, 100].map(val => (
                    <a className="dropdown-item" onClick={setPageListItems} data-value={val} key={val}>{val} records</a>
                  ))}
                </div>
              </div>
              <ul className="pagination m-0 ms-auto">
                <li className={`page-item${page === 0 ? ' disabled' : ''}`}>
                  <a className="page-link" href="#" tabIndex="-1" aria-disabled={page === 0}
                    onClick={e => { e.preventDefault(); if (page > 0) setPage(page - 1); }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M15 6l-6 6l6 6" />
                    </svg>
                    prev
                  </a>
                </li>
                {[...Array(totalPages)].map((_, idx) => (
                  <li key={idx} className={`page-item${page === idx ? ' active' : ''}`}>
                    <a className="page-link" href="#" onClick={e => { e.preventDefault(); setPage(idx); }}>{idx + 1}</a>
                  </li>
                ))}
                <li className={`page-item${page === totalPages - 1 ? ' disabled' : ''}`}>
                  <a className="page-link" href="#" aria-disabled={page === totalPages - 1}
                    onClick={e => { e.preventDefault(); if (page < totalPages - 1) setPage(page + 1); }}>
                    next
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M9 6l6 6l-6 6" />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.3)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">{editId ? 'Edit Accomodation' : 'Create Accomodation'}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Pilih Event</label>
                    <select
                      className="form-select"
                      name="event"
                      value={form.event}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Pilih Event</option>
                      {events.map((event) => (
                        <option key={event.id} value={event.id}>
                          {event.eventCode} - {event.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Nama Hotel</label>
                    <select
                      className="form-select"
                      name="hotel"
                      value={form.hotel}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Pilih Hotel</option>
                      {hotels.map((hotel) => (
                        <option key={hotel.id} value={hotel.id}>
                          {hotel.namaHotel}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Harga Kamar</label>
                    <input type="number" className="form-control" name="hargaKamar" value={form.hargaKamar} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Type Kamar</label>
                    <input type="text" className="form-control" name="typeKamar" value={form.typeKamar} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Keterangan</label>
                    <input type="text" className="form-control" name="keterangan" value={form.keterangan} onChange={handleChange} required />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">{editId ? 'Update' : 'Create'}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminAccomodation;